var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:"h-5 w-5 fill-current",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }